import IActionsResolver from 'globx/dist/Store/Interfaces/IActionsResolver';

import logger from '../../../Shared/Util/logger';

import ILocalStorage        from './Interfaces/ILocalStorage';
import ILocalStorageActions from './Interfaces/ILocalStorageActions';
import LocalStorage         from './LocalStorage';

const PLAYER_STORAGE_KEY = 'daznPlayer';

const resolveLocalStorageActions: IActionsResolver<LocalStorage, ILocalStorageActions> =
    (value: ILocalStorage): ILocalStorageActions => ({

    write(newLocalStorage: ILocalStorage): void {
        Object.assign(value, newLocalStorage);

        try {
            window.localStorage.setItem(PLAYER_STORAGE_KEY, JSON.stringify(value));
        } catch (err) {
            logger.error(err);
        }
    }

});

export default resolveLocalStorageActions;